import { render, staticRenderFns } from "./Cerveceria.vue?vue&type=template&id=8025ef6e&scoped=true&"
import script from "./Cerveceria.vue?vue&type=script&lang=js&"
export * from "./Cerveceria.vue?vue&type=script&lang=js&"
import style0 from "./Cerveceria.vue?vue&type=style&index=0&id=8025ef6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8025ef6e",
  null
  
)

export default component.exports